// This file change base on：
// https://github.com/staxmanade/CssToReact transform.js
// Purpose: transform origin string style or object style(style name contain "-") to JSX object style(style name not contain "-",use hump named)

import cssParser from "css";

function transformRules(self: any, rules: any, result: any) {
    rules.forEach((rule: any) => {
        const obj: any = {};
        if (rule.type === 'media') {
            const name = mediaNameGenerator(rule.media);
            const media = result[name] = result[name] || {
                "__expression__": rule.media
            };
            transformRules(self, rule.rules, media);
        } else if (rule.type === 'rule') {
            rule.declarations.forEach(function (declaration: any) {
                if (declaration.type === 'declaration') {
                    const cleanProperty = cleanPropertyName(declaration.property);
                    obj[cleanProperty] = declaration.value;
                }
            });
            rule.selectors.forEach(function (selector: string) {
                const name = nameGenerator(selector.trim());
                result[name] = obj;
            });
        }
    });
}

const cleanPropertyName = function (name: string) {
    // turn things like 'align-items' into 'alignItems'
    name = name.replace(/(-.)/g, function (v: any) { return v[1].toUpperCase(); });

    return name;
};

const mediaNameGenerator = function (name: string) {
    return '@media ' + name;
};

const nameGenerator = function (name: string) {
    name = name.replace(/\s\s+/g, ' ');
    name = name.replace(/[^a-zA-Z0-9]/g, '_');
    name = name.replace(/^_+/g, '');
    name = name.replace(/_+$/g, '');

    return name;
};

class Program {
    public static StyleTransfrom(inputCssText: any): object {
        // this if is required!! it judge the style is object style or string style
        if (typeof inputCssText == 'object' && JSON.stringify(inputCssText) != "{}") {
            // important comment!!!
            // This for loop is not required!!! react can support object style name contain "-", But react will show warning in develop environment,
            // Below for loop use for transform the object style that name contain "-" to hump named, like 'font-size' into 'fontSize'.
            // Add this for loop can remove react warning in develop environment,But will cause performance falling, Decide use or not by youself!!!!
            for (const key in inputCssText) {
                if (key.indexOf("-") != -1) {
                    const newKey = key.replace(/(-.)/g, function (v: any) { return v[1].toUpperCase(); });
                    inputCssText[newKey] = inputCssText[key];
                    delete inputCssText[key];
                }
            }
            return inputCssText;
        }

        // after this if, Will start transform string style to JSX object style
        if (!inputCssText || JSON.stringify(inputCssText) == "{}") {
            return {};
        }

        // If the input "css" doesn't wrap it with a css class (raw styles)
        // we need to wrap it with a style so the css parser doesn't choke.
        let bootstrapWithCssClass = false;
        if (inputCssText.indexOf("{") === -1) {
            bootstrapWithCssClass = true;
            inputCssText = `.bootstrapWithCssClass { ${inputCssText} }`;
        }

        const css: any = cssParser.parse(inputCssText);
        let result: any = {};
        transformRules(this, css.stylesheet.rules, result);

        // Don't expose the implementation detail of our wrapped css class.
        if (bootstrapWithCssClass) {
            result = result.bootstrapWithCssClass;
        }

        return result;
    }
}

export default Program.StyleTransfrom;
